import React from 'react';
import { Mail, Phone, MapPin, Printer } from 'lucide-react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import ContactForm from '../components/common/ContactForm';
import { contact } from '@/data/contact';
import { seo } from '@/data/seo';

const details = [
  {
    icon: MapPin,
    title: 'Address',
    body: contact.addressLines,
  },
  {
    icon: Mail,
    title: 'Email',
    body: [contact.email],
    href: `mailto:${contact.email}`,
  },
  {
    icon: Phone,
    title: 'Phone',
    body: [contact.phoneDisplay],
    href: contact.phoneHref,
  },
  {
    icon: Printer,
    title: 'Fax',
    body: [contact.faxDisplay],
  },
];

const Contact = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.contact} />
      <PageHero
        eyebrow="Contact us"
        title="MAYAN Technology"
        highlight="Amman, Jordan"
        description="Princess Zein bint Al-Hussein Street, Umm al-Summaq, Building #88, 2nd floor."
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {details.map((item) => (
              <div key={item.title} className="bg-white border border-gray-200 rounded-2xl p-6">
                <div className="w-12 h-12 bg-[#398024] rounded-lg flex items-center justify-center mb-4">
                  <item.icon className="text-white" size={22} />
                </div>
                <h2 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h2>
                {item.href ? (
                  <a href={item.href} className="text-gray-600 text-sm hover:text-[#398024]">
                    {item.body.join(' ')}
                  </a>
                ) : (
                  item.body.map((line) => (
                    <p key={line} className="text-gray-600 text-sm">
                      {line}
                    </p>
                  ))
                )}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div className="bg-white border border-gray-200 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Send a message</h2>
              <ContactForm idPrefix="page-contact" />
            </div>
            <div className="rounded-2xl overflow-hidden border border-gray-200 min-h-[420px]">
              <iframe
                title="MAYAN Technology office location in Umm al-Summaq, Amman"
                src={contact.mapEmbed}
                width="100%"
                height="100%"
                className="min-h-[420px] w-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
